export default "__VITE_ASSET__B$EdGRoN__"